import React from "react";
import { Badge } from "./ReportTypeBadge.styles";
import type { ReportTypeBadgeProps } from "./ReportTypeBadge.types";

export const ReportTypeBadge: React.FC<ReportTypeBadgeProps> = ({
  label,
  className,
  "data-testid": testId,
}) => (
  <Badge className={className} data-testid={testId}>
    {label}
  </Badge>
);

export default ReportTypeBadge;
